import { render, staticRenderFns } from "./ExtraPopover.vue?vue&type=template&id=d87268f8&scoped=true&"
import script from "./ExtraPopover.vue?vue&type=script&lang=js&"
export * from "./ExtraPopover.vue?vue&type=script&lang=js&"
import style0 from "./ExtraPopover.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ExtraPopover.vue?vue&type=style&index=1&id=d87268f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87268f8",
  null
  
)

export default component.exports